import { config } from './config'

const errorMessage = (status, statusText) => {
  console.log('Referral | Notify API Error', status, statusText)
}

const getId = (url) => {
  if (!config.referral.key) return null
  return url.substring(url.indexOf(config.referral.key) + config.referral.key.length + 1, url.length);
}

const isPartner = (url) => {
  return config.referral.key && url.includes(config.referral.key)
}

const notify = (url) => {
  const xhr = new XMLHttpRequest()

  xhr.onload = () => {
    xhr.status !== 200 && errorMessage(xhr.status, xhr.statusText)
  }
  xhr.onerror = () => {
    errorMessage(xhr.status, xhr.statusText)
  }

  xhr.open('PUT', config.referral.notifyAPIUrl)
  xhr.setRequestHeader('Content-Type', 'application/json')

  const esaid = getId(url)
  if (esaid) {
    xhr.send(JSON.stringify({
      esaid,
      url
    }))
  }
}

export const partner = {
  isPartner,
  getId,
  notify
}